module.exports = __webpack_public_path__ + "static/media/darkgrey.aedec8af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/darkgrey.jpg
// module id = 160
// module chunks = 0